'use client';

import { c as _c } from "react/compiler-runtime";
import { unescape } from 'lodash';
import { useEffect, useState } from 'react';
import { cn } from '@src/utils/tailwind';
export interface AnimatedSliderProps {
  sliders?: Array<{
    reverseDirection?: boolean;
    imageSrc: string;
  }>;
  isDarkFade?: boolean;
}
const useImageWidth = src => {
  const $ = _c(3);
  const [width, setWidth] = useState(2000);
  let t0;
  let t1;
  if ($[0] !== src) {
    t0 = () => {
      const image = new Image();
      image.src = src;
      image.onload = () => {
        setWidth(image.width);
      };
    };
    t1 = [src];
    $[0] = src;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return width;
};
const Rail = t0 => {
  const $ = _c(7);
  const {
    reverse,
    imageSrc
  } = t0;
  const width = useImageWidth(imageSrc);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("h-[100px] bg-contain bg-repeat-x lg:h-[164px]");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `url(&quot;${imageSrc}&quot;)`;
  let t3;
  if ($[1] !== t2) {
    t3 = unescape(t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = width * 3;
  const t5 = reverse ? "var(--animate-scroll-right)" : "var(--animate-scroll-left)";
  let t6;
  if ($[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
    t6 = <div className={t1} style={{
      backgroundImage: t3,
      width: t4,
      animation: t5
    }} />;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
const FadeBlock = t0 => {
  const $ = _c(6);
  const {
    isRight,
    isDarkFade
  } = t0;
  const t1 = isDarkFade && !isRight;
  const t2 = isDarkFade && isRight;
  let t3;
  if ($[0] !== isRight || $[1] !== t1 || $[2] !== t2) {
    t3 = cn("pointer-events-none absolute z-10 h-full w-24 bg-gradient-to-r from-white to-white/0 lg:w-full lg:max-w-lg", {
      "right-0": isRight,
      "from-white/0 to-white": isRight,
      "from-[#1D1F20] to-black/0": t1,
      "from-black/0 to-[#1D1F20]": t2
    });
    $[0] = isRight;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export const AnimatedSlider = t0 => {
  const $ = _c(11);
  const {
    sliders: t1,
    isDarkFade
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sliders = t2;
  if (sliders.length === 0) {
    return null;
  }
  let t3;
  if ($[2] !== sliders) {
    t3 = sliders.map(_temp);
    $[2] = sliders;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] !== isDarkFade) {
    t4 = <FadeBlock isDarkFade={isDarkFade} />;
    t5 = <FadeBlock isRight={true} isDarkFade={isDarkFade} />;
    $[4] = isDarkFade;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div className="relative flex flex-col gap-[18px] overflow-hidden">{t3}{t4}{t5}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(slider, index) {
  return <Rail key={index} imageSrc={slider.imageSrc} reverse={slider.reverseDirection} />;
}